import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import intl from 'react-intl-universal';
import debounce from 'lodash.debounce'
import styled from 'src/ui/library/styled';
import TextField from "src/ui/library/TextField";
import { MenuItem } from '@mui/material';

const styles = theme => ({
  clearIndicator: {
    display: 'none',
  },
  root: {
    display: 'contents'
  }
})

class AutocompleteBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsObject: null,
      options: [],
      value: null,
      inputVal: props.defaultValue && props.defaultValue !== "" ? props.defaultValue[props.labelKey] : "",
      valueObject: props.defaultValue || null,
      isOpen: false,
    };
    this.debouncedLoadOptions = debounce(this.loadOptions, 400);
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.defaultValue) !== JSON.stringify(this.props.defaultValue))
      this.setState({
        options: [],
        valueObject: this.props.defaultValue || null,
        inputVal: this.props.defaultValue && this.props.defaultValue !== "" ? this.props.defaultValue[this.props.labelKey] : "",
      });
  }

  componentWillUnmount() {
    if (this.debouncedLoadOptions) {
      this.debouncedLoadOptions.cancel();
    }
  }

  handleFocus = async () => {
    this.setState({ options: [], value: null })
  };

  handleBlur = async (e) => {
    await this.setState({
      inputVal: this.props.defaultValue && this.props.defaultValue !== "" ? this.props.defaultValue[this.props.labelKey] : "",
      value: null
    })
  };

  handleChange = async (event, newValue) => {
    const { labelKey, onChange } = this.props;
    const { optionsObject } = this.state;
    const optionSelected = optionsObject && optionsObject.find((add) => add[this.props.valueKey] === newValue);
    // newValue is the option object selected from the dropdown or null if cleared
    let valueObj = {}
    if (optionSelected) {
      this.props.setExactInput(optionSelected[this.props.labelKey]);
      valueObj[labelKey] = optionSelected && optionSelected[this.props.labelKey];
    } else {
      valueObj = null;
    }

    this.setState({
      //optionsObject: optionSelected, 
      options: [],
      inputVal: optionSelected ? optionSelected[labelKey] : "",
      value: newValue || null,
      valueObject: newValue || null,
    }, () => {
      if (onChange) {
        onChange(valueObj, optionSelected);
      }
    });
    this.inputRef.focus();
  };


  handleInputChange = (e, newvalue, reason) => {
    if (reason === "input") {
      if (newvalue === "") {
        this.handleChange(e, null)
      }
      let inputValue = newvalue
      this.props.setExactInput(inputValue);
      this.setState({ inputVal: inputValue, value: null })
      this.debouncedLoadOptions(inputValue);
    }
  }

  loadOptions = async (inputValue) => {
    try {
      const result = await this.props.loadOptions(inputValue);
      this.setState({
        optionsObject: result,
        options: result && result.map(address => address[this.props.valueKey]),
      });
    } catch (error) {
      this.setState({
        optionsObject: [],
        options: [],
        value: null,
        inputVal: this.props.defaultValue && this.props.defaultValue !== "" ? this.props.defaultValue[this.props.labelKey] : "",
      });
      console.error('Error fetching options:', error);
    }
  };

  setInputRef = el => {
    this.inputRef = el;
  };


  render() {
    const { disabled, classes, noResultsText, textfieldstyle, textfieldvariant, label, required, isExtendedLabel, isQuestionnaireControl } = this.props;
    const { options, inputVal, value, isOpen , valueObject} = this.state;
    const inputLabel = label || intl.get("profile.addressln1");
    const comboBoxInstruction = `${inputLabel}${required ? ` ${intl.get('questionnaire.requiredLabel')}` : ''} editable combo-box use the arrow keys or type the answer`;

    return (
      <Autocomplete
        disabled={disabled}
        noOptionsText={noResultsText}
        filterOptions={(options) => options}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        //value={value || null}
        value={valueObject}
        options={options}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        inputValue={inputVal}
        renderInput={(params) => {
          return <TextField
            {...params}
            removedisablefocus={this.props.removedisablefocus || false}
            extraTextforReader={this.props.extraTextforReader || null}
            inputRef={this.setInputRef}
            value={inputVal}
            variantType={textfieldvariant}
            //styleType={"profile"}
            styleType={textfieldstyle}
            labelOutside={true}
            label={inputLabel}
            required={required}
            isQuestionnaireControl={isQuestionnaireControl}
            inputProps={{
              ...params.inputProps,
              ...(isExtendedLabel ? {
                role: 'combobox',
                'aria-autocomplete': 'list',
                'aria-haspopup': 'listbox',
                'aria-expanded': isOpen,
                'aria-label': comboBoxInstruction,
              } : {
                role: 'textbox',
                'aria-expanded': null,
              }),
              onBlur: (e) =>
                // setTimeout(() => {
                //   params.inputProps.onBlur?.(e);
                // }, 0),
                {
                  console.log(e,document.activeElement)
                  this.setState({ isOpen: false, inputVal: this.state.valueObject && this.state.valueObject !== null ? valueObject.label : '' });
                  setTimeout(() => {
                    params.inputProps && params.inputProps.onBlur(e);
                  }, 0)
                  
                }
            }}
          />
        }
        }
        openOnFocus={true}
        open={this.state.isOpen}
        onOpen={() => this.setState({ isOpen: true })}
        onClose={() => this.setState({ isOpen: false, inputVal: this.state.valueObject && this.state.valueObject !== null ? valueObject.label : '' })}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          console.log(option)
          console.log(props)
          
          return <MenuItem key={key}
          {...optionProps} tabIndex={0} >
            {option}
          </MenuItem>
          
        }}
        defaultValue={null}
        classes={{
          clearIndicator: classes.clearIndicator,
          popupIndicator: classes.clearIndicator,
          root: classes.root
        }}
      />
    );
  }
}

export { AutocompleteBase };
export default styled(AutocompleteBase)(styles);